import {atom} from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist({
  key: "recoil-persist",
});

export const themeAtom = atom<"light" | "dark">({
  key: "themeMode",
  default: "light",
  // effects_UNSTABLE: [persistAtom],
});
